import { Paper } from '@mantine/core'
import { Patient } from '@medplum/fhirtypes'

import { MessagesPage } from '@/pages/Messages'

type MessagesCollapsableContainerProps = {
  patient?: Patient
  /** Open state — owned by the caller, which also renders the toggle
   * (`<MessagesActionButton>` in the patient header's action group). */
  isActive: boolean
  /** A thread to open once the panel lists it (a `?messages=` link). */
  focusThreadId?: string | null
  onClose: () => void
}

export const MessagesCollapsableContainer = ({
  patient,
  isActive,
  focusThreadId,
  onClose,
}: MessagesCollapsableContainerProps) => {
  return (
    <div
      className={[
        'fixed right-0 z-[99] overflow-hidden transition-[width,opacity] duration-300 ease-out',
        isActive ? 'w-[700px] opacity-100' : 'w-0 opacity-0',
      ].join(' ')}
      style={{ top: 60, height: 'calc(100vh - 60px)' }}
    >
      <Paper withBorder className="relative z-[1000] h-full">
        {/* Mounted only while open. A collapsed panel is hidden by CSS alone, so
            keeping it mounted left a live Messages page loading threads and
            marking the patient's newest conversation read behind the user's
            back — the drawer must do nothing until it is actually opened. */}
        {isActive && (
          <MessagesPage
            preselectedPatient={patient}
            focusThreadId={focusThreadId}
            showMinimizedView
            onClose={onClose}
          />
        )}
      </Paper>
    </div>
  )
}
